// Helpers

window._isObject = function (obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
};

window._isBool = function (bool) {
    return typeof bool === 'boolean';
};

window.humanFileSize = function (bytes, si = true, dp = 2) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(dp) + ' ' + units[u];
}

String.prototype.shuffle = function () {
    const a = this.split('');
    const n = a.length;

    for (let i = n - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join('');
}

// Bootstrap, jQuery, other libs
try {
    window.jQuery = window.$ = require('jquery');
    require('jquery.easing')(jQuery);
    require('bootstrap');
} catch (e) {
}

window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

// Vue

window.Vue = require('vue').default;
Vue.use(require('vue-uuid').default);
Vue.component('ValidationProvider', require('vee-validate').ValidationProvider);
Vue.component('ValidationObserver', require('vee-validate').ValidationObserver);
Vue.component('select2', require('v-select2-component').default);
Vue.component('custom-select', require('./components/CustomSelect.vue').default);
Vue.component('action-button', require('./components/ActionButton.vue').default);
Vue.component('list-editor', require('./components/ListEditor.vue').default);
Vue.component('keep-toggle', require('./components/KeepToggle.vue').default);
Vue.component('share-manager', require('./components/ShareManager.vue').default);
Vue.component('schedule-manager', require('./components/ScheduleManager.vue').default);
Vue.component('release-manager', require('./components/ReleaseManager.vue').default);

Vue.component('universal', require('./components/Reports/Universal/Universal.vue').default);

Vue.component('industrie-standard', require('./components/Reports/IndustrieStandard.vue').default);
Vue.component('industrie-bonus', require('./components/Reports/IndustrieBonus.vue').default);
Vue.component('industrie-individuell', require('./components/Reports/IndustrieIndividuell.vue').default);
Vue.component('industrie-individuell2', require('./components/Reports/IndustrieIndividuell2.vue').default);
Vue.component('flyer', require('./components/Reports/Flyer.vue').default);
Vue.component('marktanalyse', require('./components/Reports/Marktanalyse.vue').default);
Vue.component('rohertrag', require('./components/Reports/Rohertrag.vue').default);
Vue.component('kassenbon', require('./components/Reports/Kassenbon.vue').default);
Vue.component('verkaufspreisanalyse', require('./components/Reports/Verkaufspreisanalyse.vue').default);
Vue.component('lager', require('./components/Reports/Lager.vue').default);
Vue.component('rabatt', require('./components/Reports/Rabatt.vue').default);

Vue.component('gh', require('./components/Reports/GH/GH.vue').default);
Vue.component('minderspanne', require('./components/Reports/GH/Minderspanne.vue').default);
Vue.component('liefer', require('./components/Reports/GH/Liefer.vue').default);
Vue.component('gh-spezial', require('./components/Reports/GH/Spezial.vue').default);

Vue.component('adas-check', require('./components/Reports/AdasCheck/AdasCheck.vue').default);
Vue.component('pzn-search', require('./components/PznSearch.vue').default);
Vue.component('chart-editor', require('./components/ChartEditor.vue').default);

Vue.use({
    install: function (Vue, options) {
        Vue.mixin({
            mounted: function () {
                $('[data-toggle="tooltip"]').tooltip();
            }
        })
    }
}, {})

Vue.prototype.$info = {
    'calculation.columns': 'Welche Informationen sollen in der Auswertung enthalten sein.',
    'pages.anbieter': 'Es gibt eine zusätzliche Auswertungsseite auf Anbieterebene. Optional in Verbindung mit PZN.',
    'pages.coops': 'Pro Kooperation in der Menge der Apotheken werden zusätzliche BGA und PZN Seiten erstellt.',
    'timing.period': 'Von: Startmonat, Bis: Endmonat, Standard und Bonus immer mit Vorjahresvergleich. Bei allen anderen kann der Vergleich ausgewählt werden. Außer Lagerbestand und Rabattauswirkung.',
    'timing.month': 'Hier wird der Hauptmonat ausgewählt und wieviele Vor- und Nachmonate sollte betrachtet werden.',
    'sellInOut.mode': 'Welcher Bezugsweg soll beim Einkauf / Verkauf ausgewertet werden. Anbieter bedeutet nur Direktgeschäft, Großhandel nur GH-Bezüge. Anbieter und GH Summe bedeutet beide werden zusammengefasst, nur getrennt bedeutet beide werden ausgewertet und getrennt dargestellt.',
    'sellIn.mode': 'Welcher Bezugsweg soll beim Einkauf ausgewertet werden. Anbieter bedeutet nur Direktgeschäft, Großhandel nur GH-Bezüge. Anbieter und GH Summe bedeutet beide werden zusammengefasst, nur getrennt bedeutet beide werden ausgewertet und getrennt dargestellt.',
    'sellIn.modeSwitch': 'Auswahl des Bezugwegs für die Berechung der Überweiser.',
    'sellOut.removeTax': 'Bei Aktivierung werden die Nettopreise berechnet, ansonsten die Bruttopreise.',
    'sellIn.discount': 'Wenn aktiviert, dann wird der durchschnittliche Direktrabatt im Zeitraum ausgewertet (ListenEK zu NettoEk).',
    'panel.panelPercent': 'Wieviele Apotheken sollen ausgewertet werden? Bei einem Wert unter 100% wird am Ende die PZN Auswertung hochgerechnet.',
    'panel.panelBase': 'Welcher Bezugsweg ist der Faktor für die Panelgröße und die Hochrechnung?',
    'panel.panelPeriod': 'In welchen Zeitintervallen soll das Apothekenpanel betimmt werden. Gesamtzeitraum bedeutet, dass alle Apotheken die irgendwann in dem ausgewählten Zeitraum aktiv waren für den gesamten Zeitraum betrachtet werden.\n' +
        'Quartalsweise: Apothekenpanel wird je Quartal angepasst. Anfang - Apotheken müssen im gesamt Quartal aktiv gewesen sein. Mitte - Apotheken müssen mindestens die hälfte des Quartals aktiv gewesen sein. Ende - Apotheken müssen irgendwann im Quartal aktiv gewesen sein.\n' +
        'Monatlich bedeutet, dass das Panel monatlich auf die aktiven Apotheken angepasst wird.',
    'kassenbon.left': 'Auswahl der Kriterien für die Kassenbonauswertung.',
    'kassenbon.right': 'Auswahl der Kriterien für Zweitverkäufe.',
    'rabatt.mode': 'Automatisch bestimmen: aus dem Wareneingang (ListenEK zu NettoEK). Manuell: einen Rabattwert eingeben.',
    'rabatt.ghPercent': 'Durchschnittliche Kondition beim Erstlieferanten.',
    'rabatt.comparePercent': 'Neues Rabattangebot des Partners.',
    'lager.salesMode': 'Obere und/oder untere Grenzen für Einkaufs- oder Verkaufspreise. Z.B. alles zwischen 10 und 20 € Einkaufspreis auswerten.',
    'lager.stockMode': 'Obere und/oder untere Grenzen für Anzahl der Packungen an Lager. Z.B. alles auswerten mit mehr als 20 Packungen an Lager.',
    'lager.verfallMode': 'Angabe eines Zeitraum bis wann der Artikel abgelaufen ist. Z.B. alle Artikel auswerten mit einer Haltbarkeit bis 31.12.2022.',
    'lager.anLagerMode': 'Soll das Produkt an Lager sein? Alle bedeutet keine Angabe.',
    'verkauf.leftBase': 'Basis für den Preisvergleich.',
    'verkauf.rightBase': 'Mit welchem Preis soll verglichen werden.',
    'verkauf.compare': 'Welche Vergleichsbedingung gibt es.',
    'flyer.mode': 'Welcher Bezugsweg soll ausgewertet werden.',
    'flyer.marketingTool': 'Falls aktiviert, werden BGA und PZN Daten für den gewählten Monat aus dem Marketing Tool geladen. Die Filter unten können zur weiteren Filterung benutzt werden.',
    'flyer.sellInOutBase': 'Welche Umsatzgröße soll ausgewertet werden.',
    'markt.panelFilter': 'Auf welche PZN-Gruppe, auf welchen Anbieter soll eine Performance berechnet werden um das Apothekenpanel zu bestimmen.',
    'gh.apoListe': 'Apotheken werden über die Liste vom Typ "Apotheken mit GH" ermittelt. Das Feld "Apotheken" unter "Filter" kann zur weiteren Filterung dieser verwendet werden.',
    'gh.ms.wholesaler': 'Welche Liste welches Großhändlers soll ausgewertet werden?',
    'gh.liefer.wholesaler': 'Welche GH sollen verglichen werden?',
    'gh.liefer.einkauf': 'Obere und/oder untere Grenzen für Einkaufspreis. Z.B. alle Artikel unter 10 €.',
    'gh.spezial.periodMode': 'Sollen die Absätze und Umsätze summiert oder monatlich ausgegeben werden?',
    'filter.pharmacies': 'Man kann eine manuelle Excel Liste hochladen (Vorlage dazu steht zum Download bereit). Man kann eine bereits angelegte Liste auswählen oder BGA manuell hinzufügen. Zudem kann man alle Apotheken einer Kooperation hinzufügen.',
    'filter.pzn': 'Man kann eine manuelle Excel Liste hochladen (Vorlage dazu steht zum Download bereit). Man kann eine bereits angelegte Liste auswählen oder PZN manuell hinzufügen.',
    'filter.pznGroups': 'Hier können mehrere PZN einer Übergruppe zugeordnet werden. Z.B. alle Voltaren oder Asprin.',
    'filter.abgaberegelung': 'Welche PZN welcher Abgaberegelung soll ausgewählt werden. (Einfachauswahl)',
    'filter.anbieter': 'Welche/r Anbieter sollen ausgewertet werden. (Mehrfachauswahl möglich)',
    'filter.warengruppen': 'Welche Warengruppe/n sollen ausgewertet werden. (plus untere) bedeutet, dass die Hauptgruppe plus alle dazugehörigen Untergruppen ausgewertet werden. (Mehrfachauswahl möglich)',
    'filter.wirkstoffe': 'Welche/r Hauptwirkstoff/e sollen ausgewertet werden. (Mehrfachauswahl möglich). Verknüpfung mit Warengruppen: wenn aktiviert, dann werden die Warengruppen und zusätzliche alle Artikel mit den augewählten Hauptwirkstoffen außerhalb der Warengruppe/n ausgewertet. Ansonsten werden nur Artikel mit dem Hauptwirkstoff in den ausgewählten Warengruppen ausgewertet.',
    'filter.dar': 'Welche Darreichungsform soll bei der Auswertung betrachtet werden. (Mehrfachauswahl möglich)',
    'filter.groesse': 'Welche Einheit der Größenangabe soll ausgewertet werden. Und welche Packungsgröße (inkl. Abweichung).',
    'filter.reimport': 'Sollen Reimporte ausgewertet werden? Alle bedeutet keine Angabe. Keine Reimporte bedeutet, alles außer Reimporte.',
};

// check if url contains debug flag
const urlParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());
Vue.prototype.$debugEnabled = '_debug' in urlParams;

window.app = new Vue({
    el: '#wrapper'
});

// SB Admin 2
require('startbootstrap-sb-admin-2/js/sb-admin-2');

// Init
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});
